import { createContext } from 'react';

export const VideoContext = createContext(null);